import BaseFile from '@/modules/common/models/file/base-file.ts';
import { State } from '@/modules/common/enums/state.ts';

export default abstract class UploadFile extends BaseFile {
  state: State = State.Undefined;
  error?: string;
  base64?: string;
  revision?: number;
  revisionActive: boolean = false;

  setRevision(revision: number | undefined, active: boolean) {
    this.revision = revision;
    this.revisionActive = active;
  }
}
